import { funcState } from '../../utils/funcState';
import { Filters } from '../utils/filtersEnum';

const CovidFilterProvider = ({ updateFilter }) => {
  const [covidOnly, setCovidOnly] = funcState(false);
  const [currentCategoryTag, setCurrentCategoryTag] = funcState();
  const [locale, setLocale] = funcState();

  const update = ({ categoryData, locale: localeProp, queryParams }) => {
    setCurrentCategoryTag(categoryData.tag);
    setLocale(localeProp);

    const categoryTags = categoryData?.query?.tag;
    const queryCovid = queryParams?.covid ?? false;

    if (
      (categoryTags?.length && categoryTags.indexOf('covid-19') !== -1) ||
      queryCovid === 'true'
    ) {
      setCovidOnly(true);
    } else {
      setCovidOnly(false);
    }

    updateFilter({
      key: Filters.Covid,
      value: { covidOnly: covidOnly.value },
    });
  };

  const toQueryParams = () => {
    return {
      covid: covidOnly.value,
    };
  };

  const pushHistory = (obj) => {
    const isCovidSelected = obj.covid === 'true';
    if (
      !isCovidSelected &&
      currentCategoryTag.value === `${locale.value}--covid-19`
    ) {
      return `/${locale.value}/all-events`;
    }

    return null;
  };

  const defaultFilters = {
    covid: undefined,
  };

  const hasActiveFilters = () => {
    return covidOnly.value;
  };

  return {
    exposed: {},
    update,
    toQueryParams,
    pushHistory,
    defaultFilters,
    hasActiveFilters,
  };
};

export default CovidFilterProvider;
